//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { callApp, isWeiXin, system } from '@/util/const'
  import CallUp from 'tool-callapp'

  export default {
  props: {
    Type: Number,
    userData: Number,
    jumpType: Number
  },
  components: {
  // 'Input': Input,
    },
  data () {
    return {
      openInBrowser: false,
      isIos: system(),
      isWeiXin: isWeiXin(),
    }
  },

  methods: {
      closeit(){
        this.$emit('closeBox');
      },
    jump() {
      let url = 'openpage://50200'
      window.location.href = url
    },
    goMylink(){
      if (this.isWeiXin) {
        this.openInBrowser = true
        return
      }
      const url = 'openpage://50200'
      const callup = new CallUp({
        // 协议头
        PROTOCAL: 'launchmylink',

        HOME: '',

        // 唤起失败时的跳转链接
        FAILBACK: {
          ANDROID: 'market://details?id=com.ChinaMobile',
          IOS: 'https://itunes.apple.com/hk/app/mylink-hk/id483513425?mt=8'
        },

        // Android apk 相关信息
        APK_INFO: {
          PKG: 'com.ChinaMobile.push',
          CATEGORY: 'android.intent.category.DEFAULT',
          ACTION: 'android.intent.action.VIEW'
        },

        // 唤起超时时间，超时则跳转到下载页面
        LOAD_WAITING: 3000
      })
      callup.loadSchema({
        targetURI: url
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/birthday/BoxWindow.vue